module.exports = __webpack_public_path__ + "h5/img/gjss@2x.76a09636.png";